import { render, staticRenderFns } from "./EditRecipient.vue?vue&type=template&id=1c77c1f0&"
import script from "./EditRecipient.vue?vue&type=script&lang=js&"
export * from "./EditRecipient.vue?vue&type=script&lang=js&"
import style0 from "./EditRecipient.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports